/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./summaryEmail.vue?vue&type=template&id=d52abbca&scoped=true&"
import script from "./summaryEmail.vue?vue&type=script&lang=js&"
export * from "./summaryEmail.vue?vue&type=script&lang=js&"
import style0 from "./summaryEmail.vue?vue&type=style&index=0&id=d52abbca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52abbca",
  null
  
)

export default component.exports